import * as React from "react";
import MuiFormLabel, {
    FormLabelProps as MuiFormLabelProps,
    FormLabelClassKey as MuiFormLabelClassKey
} from "@material-ui/core/FormLabel";

export type FormLabelClassKey = MuiFormLabelClassKey;

export interface FormLabelProps extends MuiFormLabelProps { }

class FormLabel extends React.PureComponent<FormLabelProps> {
    render() {
        const { ...props } = this.props;
        return <MuiFormLabel {...props}>
            {this.props.children}
        </MuiFormLabel>;
    }
}

export default FormLabel; 